<template>
  <div>
    <b-autocomplete
      v-model="templateId"
      label="Маршрут"
      placeholder="оберіть маршрут"
      :items="$directory.get('templateList')"
      :loading="$loading.isLoading('templateList')"
      :error-messages="getErrorMessages(v$.templateId)"
      @blur="v$.templateId.$touch()"></b-autocomplete>
  </div>
</template>

<script lang="ts">
import { ref } from 'vue'
import { getErrorMessages } from 'best-modules/utils'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { fillDirectory } from '@/directory'

export default {
  name: 'TemplateSelect',
  methods: { getErrorMessages },
  setup() {
    fillDirectory('templateList')
    const templateId = ref()

    const v$ = useVuelidate({ templateId: { required } }, { templateId })

    const submit = () => {
      return Promise.resolve(templateId.value)
    }

    return { templateId, v$, submit }
  },
}
</script>

<style scoped lang="scss"></style>
